export const flattenModuleCompositionRow = (row) => {
    if (row == null || typeof row !== "object") {
        return row
    }
    const nested = row.module && typeof row.module === "object" ? row.module : {}
    return {
        ...nested,
        ...row,
        id: row.id,
        moduleCompositionId: row.id,
        moduleId: nested.id,
        module: nested,
        name: row.name ?? nested.name,
        groupName: row.groupName ?? nested.groupName,
        sideBaseModule: row.sideBaseModule ?? nested.sideBaseModule,
        heightLocation: nested.heightLocation ?? row.heightLocation,
        priority: row.priority,
        width: nested.width ?? row.width,
        height: nested.height ?? row.height,
        depth: nested.depth ?? row.depth,
        minWidth: nested.minWidth ?? row.minWidth,
        minHeight: nested.minHeight ?? row.minHeight,
        minDepth: nested.minDepth ?? row.minDepth,
        maxWidth: nested.maxWidth ?? row.maxWidth,
        maxHeight: nested.maxHeight ?? row.maxHeight,
        maxDepth: nested.maxDepth ?? row.maxDepth,
    }
}

export const mergeModuleCatalogFields = (row, moduleData) => {
    if (row == null || moduleData == null || typeof moduleData !== "object") {
        return row
    }
    return {
        ...row,
        name: row.name || moduleData.name,
        groupName: row.groupName || moduleData.groupName,
        sideBaseModule: row.sideBaseModule || moduleData.sideBaseModule,
        heightLocation: row.heightLocation ?? moduleData.heightLocation,
    }
}
